export const OPTOUT = 'consentsmanagement_device';
